import setInboxAndSweepRulesService from '../services/setInboxAndSweepRulesService';
import store from '../store/store';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import { action, select } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
/**
 * Saves the current inbox rule configuration
 */
export default select({
    optionState: function () { return store.inboxRulesListState; },
})(action('setInboxRules', datapoints.setInboxRulesDatapoint)(function setInboxRules(state) {
    var datapoint = returnTopExecutingActionDatapoint();
    var optionState = state.optionState;
    var inboxRuleIds = optionState.inboxRuleIds;
    var inboxRuleMap = optionState.inboxRules;
    return setInboxAndSweepRulesService(inboxRuleIds, inboxRuleMap)
        .then(function (response) {
        if (!response.WasSuccessful) {
            var errorMessage = response.ErrorMessage
                ? response.ErrorMessage
                : 'Response WasSuccessful was false';
            datapoint.endWithError(DatapointStatus.ServerError, new Error(errorMessage));
        }
    })
        .catch(function (error) {
        datapoint.endWithError(DatapointStatus.ServerError, error.message);
    });
}));
//# sourceMappingURL=setInboxRules.js.map